module.exports = __webpack_public_path__ + "img/figma.c80be9d6.svg";